const ICON_WIDTH_AND_MARGIN = 34;
export { ICON_WIDTH_AND_MARGIN, };
//# sourceMappingURL=tab-control-constants.js.map